import ExtensionPage from 'flarum/admin/components/ExtensionPage';
import StatisticsWidget from './StatisticsWidget';
export default class StatisticsPage extends ExtensionPage {
  content() {
    return m("div", {
      className: "StatisticsPage"
    }, m("div", {
      className: "container"
    }, m(StatisticsWidget, null)));
  }
}
flarum.reg.add('flarum-statistics', 'admin/components/StatisticsPage', StatisticsPage);